import { NotificationEnum } from '@arpeggi/shared'
import { IArpMedia } from '../../arp-registry/ArpMedia'

export const extractNotificationMessage = (type: NotificationEnum, media: IArpMedia) => {
  const title = media.metadata.title
  let msg = ''
  if (type === NotificationEnum.ARP_FAVORITED) msg = 'favorited'
  if (type === NotificationEnum.ARP_USED) msg = 'remixed'
  if (type === NotificationEnum.MINT_COMPLETED) msg = 'minted'
  return `${msg} ${title}`
}
